export default __webpack_public_path__ + "static/media/line-v-19.42689da7.png";